module.exports = __webpack_public_path__ + "static/media/ic_email_template.2b1780a4.svg";